import { IApiCounters } from 'affiny-core/modules/api/models/counters/counters.types';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const CountersResource = {
  getCounters: () =>
    AffinyEndpoint.Counters.url(`/`).get().json<IApiCounters>(),
};
